query User {
    user {
        appMetadata
    }
}
